import css from './InfoboxMarkup.module.scss';

export default ({title, marker, records, subTitle}) => {
  return (`
    <div class='${css.outerBox}'>
      <div class='${css.title}'>
        ${marker ? createMarker(marker) : ''}
        <div>${title}</div>
      </div>
      ${createSubtitle(subTitle)}
      <div class='${css.info}'>
        ${records?.map(createRecord).join('\n')}
      </div>
    </div>
  `)
}


const createSubtitle = (subTitle) => {
  if (!subTitle) {
    return '';
  }

  return (`
    <div class="${css.subTitle}">${subTitle}</div>
  `)
}

const createMarker = (options) => {
  if (!options) {
    return '';
  }
  const {color, borderColor} = options;
  let style = [`background-color: ${color}`];
  borderColor && style.push(`border: 3px solid ${borderColor}`)
  return (`
    <div class="${css.marker}" style="${style.join(';')}"></div>
  `)
}

const createRecord = ({name, value, color}) => {
  const style = [`background-color: ${color}`];
  
  return (`
    <div class='${css.record}'>
      ${color ? `<div class="${css.marker}" style="${style.join(';')}"></div>` : ''}
      <span class='${css.name}'>${name}:</span>
      <span class='${css.value}'>${value}</span>
    </div>
  `)
}